module.exports = __webpack_public_path__ + "img/blanket_2.ec29dec8.png";